import ReactDataGrid from "@inovua/reactdatagrid-enterprise";

export const getDataGridScrollProps = (overrides = {}) => ({
  ...ReactDataGrid.defaultProps.scrollProps,
  autoHide: false,
  scrollThumbWidth: 20,
  scrollThumbOverWidth: 28,
  ...overrides
});

export default getDataGridScrollProps;
